// extracted by mini-css-extract-plugin
export default {"info":"hwTJnTH7lVs05RP_tPN1","td":"s9oOlFDiTqAsz2vMgXsU","placeHolderShimmer":"ITt8jlPgD8ehpGYWJoXD"};